export const state = () => ({
    AccountConvenienceStore: [],
    AccountConvenienceStoreCount: 0,
    AccountConvenienceStoreLimit: 0,
    ConvenienceStoreFilter: [],
    ConvenienceStore: [],
})


export const mutations = {
    SetAccountConvenienceStore: (state, data) => {
        state.AccountConvenienceStore = data;
    },
    SetAccountConvenienceStoreCount: (state, data) => {
        state.AccountConvenienceStoreCount = data.count;
        state.AccountConvenienceStoreLimit = data.limit;
    },
    SetConvenienceStoreFilter: (state, data) => {
        state.ConvenienceStoreFilter = data;
    },
    SetConvenienceStore: (state, data) => {
        state.ConvenienceStore = data;
    },
}

export const getters = {
    getConvenienceStoreRegions: (state) => (parentId) => {
        if (!parentId || !state.ConvenienceStoreFilter[parentId])
            return [];
        return state.ConvenienceStoreFilter[parentId];
    },
    AccountConvenienceStoreMax: (state) => {
        return state.AccountConvenienceStoreCount >= state.AccountConvenienceStoreLimit;
    }
}

export const actions = {
    async GetAccountConvenienceStore({ dispatch, commit }, data) {
        const response = await this.$axios.post('/api/AccountConvenienceStore/List', data);
        return dispatch('_responseStatus', response, { root: true }).then((res) => {
            if (res) commit('SetAccountConvenienceStore', response.data);
            return res
        })
    },
    async GetAccountConvenienceStoreCount({ commit, dispatch }, data) {
        const response = await this.$axios.post('/api/AccountConvenienceStore/Count', data);
        return dispatch('_responseStatus', response, { root: true }).then((res) => {
            if (res) {
                commit('SetAccountConvenienceStoreCount', response.data);
            }
            return res
        })
    },
    async InsertAccountConvenienceStore({ dispatch }, data) {
        const response = await this.$axios.post('/api/AccountConvenienceStore/Insert', data);
        return dispatch('_responseStatus', response, { root: true }).then((res) => {
            return res
        })
    },
    async GetConvenienceStore({ dispatch, commit }, data) {
        const response = await this.$axios.post('/api/ConvenienceStore/List', data);
        return dispatch('_responseStatus', response, { root: true }).then((res) => {
            if (res) {
                commit('SetConvenienceStore', response.data.list);
            }
            return res
        })
    },
    async GetConvenienceStoreFilter({ dispatch, commit }) {
        const response = await this.$axios.get('/api/ConvenienceStore/Filter');
        return dispatch('_responseStatus', response, { root: true }).then((res) => {
            if (res) {
                commit('SetConvenienceStoreFilter', response.data.list);
            }
            return res
        })
    },
}
